import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../shared/services/http-client/http-client.service';
import {
  ClonarPlanoParamCommandDto,
  CreatePlanoParamCommandDto,
  PatchPlanoParamCommandDto,
  PatchPlanoParamStatusCommandDto,
  PlanoParamResponseDto,
  PlanoProdutoResponseDto,
  PlanosParamsQueryParams,
  PlanosParamsResponseDto,
} from '../../models/parametros/plano-api.model';

const PLANOS_PARAM_BASE_PATH = '/v1/planos-param';
const PLANOS_BASE_PATH = '/v1/planos';

@Injectable({
  providedIn: 'root',
})
export class PlanosApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  listarPlanosParams(params?: PlanosParamsQueryParams): Observable<PlanosParamsResponseDto> {
    return this.httpClient.get<PlanosParamsResponseDto>(PLANOS_PARAM_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  obterPlanoParam(id: number): Observable<PlanoParamResponseDto> {
    return this.httpClient.get<PlanoParamResponseDto>(`${PLANOS_PARAM_BASE_PATH}/${id}`);
  }

  criarPlanoParam(command: CreatePlanoParamCommandDto): Observable<PlanoParamResponseDto> {
    return this.httpClient.post<PlanoParamResponseDto>(PLANOS_PARAM_BASE_PATH, command);
  }

  atualizarPlanoParam(id: number, command: PatchPlanoParamCommandDto): Observable<PlanoParamResponseDto> {
    return this.httpClient.patch<PlanoParamResponseDto>(`${PLANOS_PARAM_BASE_PATH}/${id}`, command);
  }

  alterarStatusPlanoParam(
    id: number,
    command: PatchPlanoParamStatusCommandDto,
  ): Observable<PlanoParamResponseDto> {
    return this.httpClient.patch<PlanoParamResponseDto>(`${PLANOS_PARAM_BASE_PATH}/${id}/status`, command);
  }

  clonarPlanoParam(id: number, command: ClonarPlanoParamCommandDto): Observable<PlanoParamResponseDto> {
    return this.httpClient.post<PlanoParamResponseDto>(`${PLANOS_PARAM_BASE_PATH}/${id}/clonar`, command);
  }

  listarProdutos(): Observable<PlanoProdutoResponseDto[]> {
    return this.httpClient.get<PlanoProdutoResponseDto[]>(PLANOS_BASE_PATH);
  }

  private toHttpParams(params?: PlanosParamsQueryParams): HttpParams | undefined {
    if (!params) {
      return undefined;
    }

    let httpParams = new HttpParams();

    for (const [chave, valor] of Object.entries(params)) {
      if (valor != null && valor !== '') {
        httpParams = httpParams.set(chave, String(valor));
      }
    }

    return httpParams.keys().length > 0 ? httpParams : undefined;
  }
}
